import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { FloorItem, ReservationGuest } from 'src/app/features/reservations/models/Reservation';
import { ReservationsService } from 'src/app/features/reservations/services/reservations.service';
import { Patterns } from 'src/app/helpers/patterns';
import Swal from 'sweetalert2';
import { ChooseTableComponent } from '../cart-takeaway/choose-table/choose-table.component';
import { Countries } from 'src/app/models/Lookup';
import { LookupsService } from 'src/app/services/lookups.service';

@Component({
  selector: 'app-cart-guest-form',
  templateUrl: './cart-guest-form.component.html'
})
export class CartGuestFormComponent implements OnInit {
  @Input() restaurantId!: number;
  @Input() isSubmitted = false;
  @Input() changeTableLoading = false;
  @Input() isOrdered = false;

  @Output() guestFormData = new EventEmitter<any>();
  @Output() confirmChooseTable = new EventEmitter<any>();

  formGroup!: FormGroup;

  searchText = '';
  searchValid = true;
  searchLoading = false;
  searchDataList: any[] = [];
  serachGuestDate!: ReservationGuest | null;
  selectedCountry: any;
  isCleared = false;
  phoneNumberPattern = Patterns.numbers_plus;

  selectedFloor = 0;
  selectedTables: FloorItem[] = [];

  isRequired = false;
  tableRequired = false;

  data: {
    customer: any,
    tables: number[],
    isValid: boolean
  } = {
      customer: null,
      tables: [],
      isValid: true
    }

  countryLoading = false;
  countryList: Countries[] = [];
  countryListAllCodes: any = [];
  isTouched = false;

  constructor(
    private formBuilder: FormBuilder,
    private service: ReservationsService,
    private translate: TranslateService,
    private dialog: MatDialog,
    public lookupService: LookupsService
  ) { }

  ngOnInit(): void {
    this.buildForm();
    // this.formGroup.valueChanges.subscribe(value => {
    //   if (value.fName || value.lName || value.phoneNumber?.number) {
    //     this.submitData();
    //   }
    // });
    this.getAllCountries();
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      fName: [null, [
        Validators.maxLength(20)
      ]],
      lName: [null, [
        Validators.maxLength(20)
      ]],
      phoneflag: [null],
      phoneCode: [null],
      phoneNumber: [null, [
        Validators.minLength(5),
        Validators.maxLength(15)
      ]],
    });
  }
  getAllCountries() {
    this.countryLoading = true;
    this.lookupService.getCountries().subscribe((data: any) => {
      this.countryLoading = false
      this.countryList = data;
      this.setDefaultCountry();
    }, (err: any) => {
      console.error(err);
    });
  }
  flagChanged() {
    if (this.formGroup.controls['phoneflag'].value) {
      this.formGroup.controls['phoneCode'].setValue(
        this.countryList.find(
          x => x.id == Number(this.formGroup.controls['phoneflag'].value)
        )?.countryKey
      )
    } else {
      this.setDefaultCountry();
    }
    this.searchByPhoneNumber();
  }
  setDefaultCountry() {
    let phoneCountry = this.countryList.find(x => x.isdefault) || this.countryList[0];
    this.formGroup.controls['phoneflag'].setValue(phoneCountry.id);
    this.formGroup.controls['phoneCode'].setValue(phoneCountry.countryKey)
  }

  phoneHasError() {
    if (this.isSubmitted || this.isTouched) {
      if (
        this.hasError('phoneNumber', 'minlength')
        || this.hasError('phoneNumber', 'maxlength')
        || this.hasError('phoneNumber', 'required')
        || this.hasError('phoneCode', 'required')
      ) {
        return true;
      }
    }
    return false;
  }

  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }

  searchGuest(searchText: string, isPhone = false) {
    if (!searchText || (typeof (searchText) != 'string')) return;
    this.searchLoading = true;
    this.clearSearchData();
    this.service.ResCheckCustomer(this.restaurantId, searchText).subscribe(
      (data: any) => {
        this.searchLoading = false;
        this.searchDataList = data;
        if (isPhone && data.length == 1) {
          this.guestSelected(data[0]);
        }
        if (!isPhone && !data.length) {
          Swal.fire({
            icon: 'error',
            title: this.translate.instant('general.No Data Found')
          })
        }
      }, err => {
        console.error(err);
      });
  }
  searchByText(event: any) {
    if (event) { event.preventDefault(); }
    this.searchGuest(this.searchText);
    (document.querySelector('.search-text') as HTMLElement)?.focus();
  }
  clearAutocompleteList() {
    if (!this.searchText) {
      this.searchDataList = [];
    }
  }
  searchByPhoneNumber(event: any = null) {
    if (event) { event.preventDefault(); }
    let searchText = '';
    const phoneCtr = this.formGroup.controls['phoneNumber'];
    if (phoneCtr.value) {
      searchText = this.formGroup.controls['phoneCode'].value.replace('+', '') + phoneCtr.value;
    }
    this.formGroup.controls['fName'].setValue('');
    this.formGroup.controls['lName'].setValue('');
    this.searchGuest(searchText, true);
  }
  guestSelected(guest: ReservationGuest) {
    this.serachGuestDate = guest;
    this.formGroup.patchValue(this.serachGuestDate);
    this.selectedCountry = this.serachGuestDate.phoneflag;
    let phoneCountry = this.countryList.find(x => x.id == Number(this.serachGuestDate?.phoneflag));
    this.formGroup.controls['phoneflag'].setValue(phoneCountry?.id);
    this.formGroup.controls['phoneCode'].setValue(phoneCountry?.countryKey);
    setTimeout(() => this.searchText = guest.fName + ' ' + guest.lName, 0);
  }
  displayFn(option: any) {
    if (!option) return '';
    return option.fName + ' ' + option.lName;
  }
  clearSearchData() {
    this.searchDataList = [];
    this.serachGuestDate = null;
  }
  clearSearchUser() {
    this.clearSearchData();
    this.isCleared = true;
    this.formGroup.reset();
    this.searchText = '';
    let phoneCountry = this.countryList.find(x => x.isdefault) || this.countryList[0];
    this.formGroup.controls['phoneflag'].setValue(phoneCountry.id);
    this.formGroup.controls['phoneCode'].setValue(phoneCountry.countryKey);
  }

  fieldsChanges() {
    let customerValues = this.formGroup.value;
    if (customerValues.fName || customerValues.lName || customerValues.phoneNumber) {
      this.isRequired = true;
      // this.tableRequired = true;
    } else {
      this.isRequired = false;
      // this.tableRequired = false;
    }
    this.formGroup.markAllAsTouched();
    this.submitData();
  }
  submitData() {
    this.isSubmitted = true;
    this.formGroup.markAllAsTouched();
    let customerValues: any = this.formGroup.value;
    customerValues.customerId = this.serachGuestDate?.customerId || 0;
    customerValues.customerPoints = this.serachGuestDate?.customerPoints;
    customerValues.isValid = this.serachGuestDate ? true : false;

    if (
      this.formGroup.valid
      && !this.serachGuestDate?.isBlackList
      && !this.serachGuestDate?.isSuspend
    ) {
      customerValues.isValid = true;
      // this.data.customer = customerValues;
    } else {
      // this.data.customer = null;
    }

    this.data.customer = customerValues;
    this.emitData();
  }

  emitData() {
    this.data.isValid = true;
    let hasCustomer = (this.data.customer && (this.data.customer.fName || this.data.customer.lName || this.data.customer.phoneNumber)) ? true : false;
    if (
      hasCustomer && !this.data.customer?.isValid
      || (this.data.tables.length && hasCustomer && !this.data.customer?.isValid)
      // || (!this.data.tables.length && hasCustomer && this.data.customer?.isValid)
      || (!this.data.tables.length && hasCustomer && !this.data.customer?.isValid)
    ) {
      this.data.isValid = false;
    }

    if (!hasCustomer) {
      this.data.customer = null;
    }

    this.guestFormData.emit(this.data);
  }

  openChooseTables() {
    const dialogRef = this.dialog.open(ChooseTableComponent, {
      width: '980px',
      data: {
        restaurantId: this.restaurantId,
        floorId: this.selectedFloor,
        tablesToSelect: this.selectedTables?.map(item => item.id)
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      // this.isRequired = false;
      if (result) {
        this.selectedTables = result.tables;
        this.selectedFloor = result.floorId;
      }
      if (this.selectedTables?.length) {
        // this.isRequired = true;
      }
      this.formGroup.markAllAsTouched();
      this.data.tables = this.selectedTables?.map(item => item.id) || [];
      this.emitData();
    });
  }

  removeTables() {
    // this.isRequired = false;
    this.selectedTables = [];
    this.selectedFloor = 0;
    this.data.tables = [];
    this.emitData();
  }

  /************************/
  confirmTable() {
    this.tableRequired = true;
    this.submitData();
    // if (this.data.customer?.isValid) {
    // }
    this.confirmChooseTable.emit(this.data);
  }
}
